import {Component, Input, OnInit} from "@angular/core";
import {NavigationState} from "../../helpers/navigation-state";
import {SearchController} from "../../helpers/search-controller";
import {DocumentService} from "../../services/document.service";
import {ModalService} from "../../services/modal.service";
import {WatchService} from "../../services/watch.service";
import {processTemplateString} from "../../utils";
import {ProfileService} from "../../services/profile.service";
import {CollectionService} from "../../services/collection.service";
import {BusService} from "../../services/bus.service";
import {QueryService} from "../../services/query.service";
import {CollectionParams} from "../../helpers/params/collection-params";
import {paramsHelper} from "../../helpers/params-helper";
import {IDocument} from "../../interfaces/document.definition";

@Component({
  selector: 'app-nv-profiles',
  templateUrl: './nv-profiles.component.html',
  styles: []
})
export class NvProfilesComponent implements OnInit {
  private _collectionParams: CollectionParams;

  @Input() set collectionParams(v: CollectionParams) {
    this._collectionParams = v;
    this.searchController.setParams(v.getSearchParams(), v.getFilterParams());
  }


  get collectionParams(): CollectionParams {
    return this._collectionParams;
  }


  list: IDocument[];
  nav: NavigationState;
  searchController: SearchController;


  constructor(public documentService: DocumentService,
              private busService: BusService,
              public profileService: ProfileService,
              private collectionService: CollectionService,
              /*private profilesService: ProfilesService,*/
              private queryService: QueryService,
              private watchService: WatchService,
              private modalService: ModalService) {
    this.searchController = new SearchController(() => this.loadList());
    this.nav = new NavigationState(() => this.loadList());
  }


  ngOnInit() {
    this.busService.onDocumentSaved
      .subscribe(() => this.loadList());

    this.loadList();

    let documentId = this.queryService.documentId;
    if (documentId) {
      this.loadImpl(documentId);
    }
  }


  loadList() {
    const params = paramsHelper.loader()
      .setEndpointProfiles()
      .setAdditionalParam("target", this.collectionParams.getTarget())
      .setNavParams(this.nav.offset, this.nav.limit)
      .setSearchParams(this.searchController.collectSearchParams());

    this.collectionService.loadChunk(params)
      .subscribe(r => {
        this.list = r.documents;
        this.nav.update(r.offset, r.count);
      });
  }


  protected onEditClick(document: IDocument, $event?: MouseEvent) {
    if ($event) {
      $event.stopPropagation();
    }

    if (this.watchService.hasChanges) {
      this.modalService.showUnsavedWarning();
      return;
    }


    this.loadImpl(document._id);
  }


  private loadImpl(documentId: string) {
    this.profileService.load(documentId, this.collectionParams.getTarget());
  }


  getDocumentLinkQueryParams(document: IDocument) {
    return {_id: document._id};
  }


  isCurrentDocument(document: IDocument): boolean {
    return this.profileService.document
      && this.profileService.document._id === document._id;
  }


  getDocumentLabel(item: IDocument): string {
    return processTemplateString(this.collectionParams.getItemLabel(), item);
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-profiles/nv-profiles.component.ts